/*
 * PBN Visual option picker engine (cards from blocks/pbn-frame-upsell.liquid).
 * Every picker works inside its own product area (.product-details): the product page
 * and the quick-add modal can both show a picker without interfering with each other.
 * The block's markup lives in the page and in the quick-add modal (copied from the
 * product page), so the engine is loaded by the block and by snippets/quick-add-modal.liquid.
 * Clicking a card clicks the matching (visually hidden) Horizon variant-picker input in
 * the same product area, so Horizon keeps owning variant selection and the add-to-cart form.
 */
(function () {
  if (window.__pbnOcEngine) return;
  window.__pbnOcEngine = true;

  var SCOPE = '.product-details';

  function scopeOf(el) {
    return (el && el.closest && el.closest(SCOPE)) || document;
  }

  /* The picker on the product page itself (not the one copied into the quick-add modal). */
  function mainScope() {
    var roots = document.querySelectorAll('[data-pbn-oc]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].closest('.quick-add-modal')) return scopeOf(roots[i]);
    }
    return document;
  }

  function data(scope) {
    var el = scope.querySelector('[data-pbn-oc-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* Writes only when the value changes, so the quick-add modal observer never loops. */
  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function setHTML(el, html) {
    if (el && el.dataset.pbnHtml !== html) {
      el.innerHTML = html;
      el.dataset.pbnHtml = html;
    }
  }

  function money(cents, fmt) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  function fieldsets(scope) {
    var picker = scope.querySelector('variant-picker');
    return picker ? Array.prototype.slice.call(picker.querySelectorAll('fieldset')) : [];
  }

  function inputValue(input, allowed) {
    if (allowed && allowed.indexOf(input.value) > -1) return input.value;
    var label = input.labels && input.labels[0];
    var text = label ? label.textContent.replace(/\s+/g, ' ').trim() : input.value;
    if (!allowed) return text;
    for (var i = 0; i < allowed.length; i++) {
      if (text === allowed[i] || text.indexOf(allowed[i]) === 0) return allowed[i];
    }
    return text;
  }

  function currentSelection(scope, d) {
    return fieldsets(scope).map(function (fs, i) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      return checked ? inputValue(checked, d && d.options[i]) : null;
    });
  }

  function findVariant(d, opts) {
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i];
      var ok = true;
      for (var k = 0; k < opts.length; k++) {
        if (v.o[k] !== opts[k]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function findInput(fs, target) {
    return Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')).find(function (i) {
      if (i.value === target) return true;
      var label = i.labels && i.labels[0];
      var text = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
      return text === target || text.indexOf(target) === 0;
    }) || null;
  }

  function syncIncludes(scope, sel) {
    var box = scope.querySelector('[data-pbn-inc]');
    if (!box) return;
    var all = sel.join(' | ').toLowerCase();
    var framed = /with frame/.test(all);
    box.querySelectorAll('[data-pbn-frame-tile]').forEach(function (tile) {
      tile.hidden = (tile.dataset.pbnFrameTile === 'framed') !== framed;
    });
    var size = null, colors = null;
    sel.forEach(function (v) {
      if (!v) return;
      var m = v.match(/^(\d+)\s+colou?rs?/i);
      if (m) colors = m[1];
      if (/\d+"\s*x\s*\d+"/.test(v)) size = v.split(' (')[0];
    });
    var sizeEl = box.querySelector('[data-pbn-inc-size]');
    if (size) setText(sizeEl, size + ', pre-printed');
    var colorEl = box.querySelector('[data-pbn-inc-colors]');
    if (colors) setText(colorEl, colors + ' colors, pre-mixed & numbered');
  }

  function refreshRoot(root) {
    var scope = scopeOf(root);
    var d = data(scope);
    var sel = d ? currentSelection(scope, d) : [];
    if (d && sel.length && sel.indexOf(null) === -1) {
      root.querySelectorAll('[data-pbn-oc-card]').forEach(function (card) {
        var oi = Number(card.dataset.oi);
        var opts = sel.slice();
        opts[oi] = card.dataset.target;
        var v = findVariant(d, opts);
        var isSel = sel[oi] === card.dataset.target;
        card.classList.toggle('is-selected', isSel);
        card.setAttribute('aria-checked', isSel ? 'true' : 'false');
        card.disabled = !v || !v.a;
        var priceEl = card.querySelector('[data-pbn-oc-price]');
        setHTML(priceEl, v ? '<strong>' + money(v.p, d.fmt) + '</strong>' + (v.c > v.p ? ' <s>' + money(v.c, d.fmt) + '</s>' : '') : '');
      });
      root.querySelectorAll('[data-pbn-oc-group]').forEach(function (g, i) {
        var current = g.querySelector('.pbn-oc__current');
        if (sel[i]) setText(current, sel[i]);
      });

      var sum = root.querySelector('[data-pbn-sum]');
      var cur = findVariant(d, sel);
      if (sum && cur) {
        var names = [];
        root.querySelectorAll('[data-pbn-oc-group]').forEach(function (g) {
          var n = g.querySelector('.is-selected .pbn-oc__name');
          if (n) names.push(n.textContent.trim());
        });
        setText(sum.querySelector('[data-sum-text]'), names.join(' · '));
        setText(sum.querySelector('[data-sum-price]'), money(cur.p, d.fmt));
        var cmp = sum.querySelector('[data-sum-compare]');
        var save = sum.querySelector('[data-sum-save]');
        if (cur.c > cur.p) {
          cmp.hidden = false;
          setText(cmp, money(cur.c, d.fmt));
          save.hidden = false;
          setText(save, 'Save ' + Math.floor((cur.c - cur.p) * 100 / cur.c) + '%');
        } else {
          cmp.hidden = true;
          save.hidden = true;
        }
        sum.classList.toggle('is-best', cur.id === d.best);
      }
    }
    syncIncludes(scope, sel);
  }

  function refresh() {
    document.querySelectorAll('[data-pbn-oc]').forEach(refreshRoot);
  }

  function waitForUpdate() {
    return new Promise(function (resolve) {
      var done = false;
      function finish() { if (done) return; done = true; document.removeEventListener('variant:update', finish); resolve(); }
      document.addEventListener('variant:update', finish);
      setTimeout(finish, 1200);
    });
  }

  async function selectVariant(scope, v) {
    var fss = fieldsets(scope);
    for (var i = 0; i < v.o.length; i++) {
      var fs = fss[i];
      if (!fs) continue;
      var input = findInput(fs, v.o[i]);
      if (!input || input.checked) continue;
      input.click();
      refresh();
      await waitForUpdate();
    }
    refresh();
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-sum-switch]');
    if (sw) {
      var swScope = scopeOf(sw);
      var d = data(swScope);
      if (!d) return;
      var best = d.variants.find(function (v) { return v.id === d.best; });
      if (best) selectVariant(swScope, best);
      return;
    }
    var card = e.target.closest('[data-pbn-oc-card]');
    if (!card || card.disabled || card.classList.contains('is-selected')) return;
    var fs = fieldsets(scopeOf(card))[Number(card.dataset.oi)];
    if (!fs) return;
    var input = findInput(fs, card.dataset.target);
    if (!input) return;
    input.click();
    refresh();
  });

  /* ---- Frame upgrade popup on Add to Cart ----
     Asked only once: the shopper's answer (yes, no or close) is remembered for 180 days.
     Never shown when the cart already has items or to returning customers.
     The click is caught on `window` in the capture phase: Horizon handles its declarative
     `on:click` handlers (including the add-to-cart "fly to cart" animation) on `document`
     in the capture phase, so a listener there would run too late. From `window` the click
     is stopped before Horizon sees it; the product only flies to the cart once the shopper
     has answered the popup. */
  var FP_KEY = 'pbnFrameChoice';
  var FP_DAYS = 180;
  var fpAllow = false;
  var ADD_SEL = 'product-form-component [name="add"], product-form-component button[type="submit"], .sticky-add-to-cart__button';

  function mainAddButton(scope) {
    return scope.querySelector('product-form-component [name="add"], product-form-component button[type="submit"]');
  }

  function seen() {
    try {
      var stamp = Number(localStorage.getItem(FP_KEY));
      if (stamp && Date.now() - stamp < FP_DAYS * 86400000) return true;
    } catch (err) {}
    try { if (sessionStorage.getItem(FP_KEY) === '1') return true; } catch (err) {}
    return false;
  }

  function markSeen() {
    try { localStorage.setItem(FP_KEY, String(Date.now())); } catch (err) {}
    try { sessionStorage.setItem(FP_KEY, '1'); } catch (err) {}
  }

  function framedPartner(d, sel) {
    var oi = d.frameOi;
    var curVal = String(sel[oi] || '');
    var low = curVal.toLowerCase();
    if (low.indexOf('no frame') === -1) return null;
    var wanted = low.replace('no frame', 'with frame');
    var values = d.options[oi] || [];
    var target = values.find(function (v) { return v.toLowerCase() === wanted; });
    if (!target) {
      var framedValues = values.filter(function (v) { return v.toLowerCase().indexOf('with frame') > -1; });
      if (framedValues.length === 1) target = framedValues[0];
    }
    if (!target) return null;
    var opts = sel.slice();
    opts[oi] = target;
    return findVariant(d, opts);
  }

  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(ADD_SEL) : null;
    if (!btn) return;
    if (fpAllow) { fpAllow = false; return; }
    var scope = btn.closest('.sticky-add-to-cart__button') ? mainScope() : scopeOf(btn);
    var dlg = scope.querySelector('[data-pbn-fp]');
    if (!dlg || seen()) return;
    var d = data(scope);
    if (!d || !d.popup || d.frameOi < 0) return;
    if (d.cartCount > 0 || d.returning) return;
    var sel = currentSelection(scope, d);
    if (!sel.length || sel.indexOf(null) > -1) return;
    var rolled = findVariant(d, sel);
    var framed = framedPartner(d, sel);
    if (!rolled || !framed || !framed.a || framed.p <= rolled.p) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    dlg.querySelector('[data-fp-rolled]').textContent = money(rolled.p, d.fmt);
    dlg.querySelector('[data-fp-framed]').textContent = money(framed.p, d.fmt);
    dlg.querySelectorAll('[data-fp-diff]').forEach(function (el) { el.textContent = money(framed.p - rolled.p, d.fmt); });
    dlg.__framed = framed;
    dlg.__scope = scope;
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
    var yes = dlg.querySelector('[data-pbn-fp-yes]');
    if (yes) yes.focus();
  }, true);

  function closeFp(dlg) {
    if (typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
  }

  function addNow(scope) {
    var b = mainAddButton(scope || document);
    if (!b) return;
    fpAllow = true;
    b.click();
    setTimeout(function () { fpAllow = false; }, 500);
  }

  document.addEventListener('click', function (e) {
    var dlg = e.target.closest('[data-pbn-fp]');
    if (!dlg) return;
    var scope = dlg.__scope || scopeOf(dlg);
    if (e.target === dlg || e.target.closest('[data-pbn-fp-close]')) {
      markSeen();
      closeFp(dlg);
      return;
    }
    if (e.target.closest('[data-pbn-fp-no]')) {
      markSeen();
      closeFp(dlg);
      addNow(scope);
      return;
    }
    var yes = e.target.closest('[data-pbn-fp-yes]');
    if (yes) {
      markSeen();
      yes.disabled = true;
      var framed = dlg.__framed;
      closeFp(dlg);
      if (!framed) { yes.disabled = false; addNow(scope); return; }
      selectVariant(scope, framed).then(function () {
        setTimeout(function () {
          yes.disabled = false;
          addNow(scope);
        }, 200);
      });
    }
  });

  document.addEventListener('cancel', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-pbn-fp]')) markSeen();
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-picker')) setTimeout(refresh, 0);
  });
  document.addEventListener('variant:update', function () { setTimeout(refresh, 30); });

  /* The quick-add modal receives its content after the page has loaded. */
  var modal = document.getElementById('quick-add-modal-content');
  if (modal && 'MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; refresh(); }, 30);
    }).observe(modal, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();